import { Badge } from "react-bootstrap";

export default function BadgeComponent({currentLength, maxLength}) {
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "2px" }}>
            <Badge>{currentLength}/{maxLength}</Badge>
        </div>
    )
}